module.exports = __webpack_public_path__ + "img/vip_setaddr.28df775a.png";